import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as KrispyTokens from '@krispy-tokens/blue';

const propTypes = {
  children: PropTypes.node,
};

const TR = styled.tr`
  border-left: 1px solid ${KrispyTokens.KrispyColorPaletteGray92};
  border-right: 1px solid ${KrispyTokens.KrispyColorPaletteGray92};
`;

const TableRow = (props) => {
  const { children } = props;

  return (
    <TR>
      {children}
    </TR>
  );
};

TableRow.propTypes = propTypes;

export default TableRow;
